/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roster_Check_In_FailInputs */

const en_roster_check_in_fail = /** @type {(inputs: Roster_Check_In_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in failed.`)
};

const es_roster_check_in_fail = /** @type {(inputs: Roster_Check_In_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error en el registro.`)
};

const fr_roster_check_in_fail = /** @type {(inputs: Roster_Check_In_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'enregistrement.`)
};

const de_roster_check_in_fail = /** @type {(inputs: Roster_Check_In_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Check-in.`)
};

const id_roster_check_in_fail = /** @type {(inputs: Roster_Check_In_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in gagal.`)
};

/** @type {(inputs: Roster_Check_In_FailInputs) => LocalizedString} */
const ja_roster_check_in_fail = en_roster_check_in_fail;

/** @type {(inputs: Roster_Check_In_FailInputs) => LocalizedString} */
const zh_roster_check_in_fail = en_roster_check_in_fail;

/** @type {(inputs: Roster_Check_In_FailInputs) => LocalizedString} */
const ar_roster_check_in_fail = en_roster_check_in_fail;

/** @type {(inputs: Roster_Check_In_FailInputs) => LocalizedString} */
const it_roster_check_in_fail = en_roster_check_in_fail;

/** @type {(inputs: Roster_Check_In_FailInputs) => LocalizedString} */
const ru_roster_check_in_fail = en_roster_check_in_fail;

/** @type {(inputs: Roster_Check_In_FailInputs) => LocalizedString} */
const pt_roster_check_in_fail = en_roster_check_in_fail;

/** @type {(inputs: Roster_Check_In_FailInputs) => LocalizedString} */
const ko_roster_check_in_fail = en_roster_check_in_fail;

/**
* | output |
* | --- |
* | "Check-in failed." |
*
* @param {Roster_Check_In_FailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const roster_check_in_fail = /** @type {((inputs?: Roster_Check_In_FailInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roster_Check_In_FailInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roster_check_in_fail(inputs)
	if (locale === "es") return es_roster_check_in_fail(inputs)
	if (locale === "fr") return fr_roster_check_in_fail(inputs)
	if (locale === "de") return de_roster_check_in_fail(inputs)
	if (locale === "ja") return ja_roster_check_in_fail(inputs)
	if (locale === "zh") return zh_roster_check_in_fail(inputs)
	if (locale === "ar") return ar_roster_check_in_fail(inputs)
	if (locale === "id") return id_roster_check_in_fail(inputs)
	if (locale === "it") return it_roster_check_in_fail(inputs)
	if (locale === "ru") return ru_roster_check_in_fail(inputs)
	if (locale === "pt") return pt_roster_check_in_fail(inputs)
	return ko_roster_check_in_fail(inputs)
});